import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import { ToastStyle } from "../app/types";

type ToastSlice = {
  show: boolean;
  message: string;
  style: ToastStyle;
  autoHideDuration: number | null;
};

const initialState: ToastSlice = {
  show: false,
  message: "",
  style: "info",
  autoHideDuration: 5000
};

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    setShowToast: (state, action: PayloadAction<boolean>) => {
      state.show = action.payload;
    },
    setToastMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    },
    setToastStyle: (state, action: PayloadAction<ToastStyle>) => {
      state.style = action.payload;
    },
    setToastAutoHideDuration: (state, action: PayloadAction<number | null>) => {
      state.autoHideDuration = action.payload;
    }
  }
});

export const {
  setShowToast,
  setToastMessage,
  setToastStyle,
  setToastAutoHideDuration
} = toastSlice.actions;
export const selectToastShow = (state: RootState) => state.toast.show;
export const selectToastMessage = (state: RootState) => state.toast.message;
export const selectToastStyle = (state: RootState) => state.toast.style;
export const selectToastAutoHideDuration = (state: RootState) =>
  state.toast.autoHideDuration;

export default toastSlice.reducer;
